// src/components/blog/Pagination.js
import React from 'react';
import styles from '../../styles/pages/Blog.module.css';

/**
 * Pagination component for navigating between pages
 * 
 * @param {Object} props - Component props 
 * @param {number} props.currentPage - Current page number (0-indexed)
 * @param {number} props.totalPages - Total number of pages
 * @param {Function} props.onPrevPage - Handler for previous page button
 * @param {Function} props.onNextPage - Handler for next page button
 */
export function Pagination({ currentPage, totalPages, onPrevPage, onNextPage }) {
  return (
    <div className={styles.navArrows}>
      <button 
        className={`${styles.navButton} ${currentPage === 0 ? styles.navButtonDisabled : ''}`}
        onClick={onPrevPage} 
        disabled={currentPage === 0}
      >
        ← Prev
      </button>
      <button 
        className={`${styles.navButtonAlt} ${currentPage === totalPages - 1 ? styles.navButtonDisabled : ''}`}
        onClick={onNextPage} 
        disabled={currentPage === totalPages - 1}
      >
        Next →
      </button>
    </div>
  );
}